import { 
  Datagrid, EditButton,
  SimpleForm, Create, TextField, TextInput,
  useNotify, useRedirect, NumberInput, Edit, TopToolbar, CreateButton, 
  ExportButton, List, ShowButton, ReferenceField, ReferenceInput, AutocompleteInput, SelectInput, downloadCSV} from "react-admin";
import { ItasEditActions } from "./util/ItasEditActions";
import { ItasToolbar } from './util/ItasToolbar'
import { ItasSearchAllFilter } from './util/ItasSearchAllFilter'
import { CustomState } from "./ImpiantiReferenceProdotti";
import { CustomPagination, choices } from "./util/generic";
import jsonExport from 'jsonexport/dist';

const exporter = (records, fetchRelatedRecords) => {
  console.log(records)
    fetchRelatedRecords(records, 'id_persona', 'persone').then(persone => {
        const data = records.map(record => ({
                ...record,
                proprietario_name: persone[record.id_proprietario].nome,
                utente_name: persone[record.id_utente].nome,
        }));
        const dataExport = data.map(record => {
          if(record.stato === "1") {  
            return {ID: record.id, Stato: "Attivo", Descrizione: record.descrizione, Indirizzo: record.indirizzo, Città: record.citta, CAP: record.cap, Provincia: record.provincia, Proprietario: record.proprietario_name, Utente: record.utente_name, Note: record.note}
          } else if(record.stato === "0") {
            return {ID: record.id, Stato: "Non attivo", Descrizione: record.descrizione, Indirizzo: record.indirizzo, Città: record.citta, CAP: record.cap, Provincia: record.provincia, Proprietario: record.proprietario_name, Utente: record.utente_name, Note: record.note}
          } else {
            return {ID: record.id, Stato: "Sospeso", Descrizione: record.descrizione, Indirizzo: record.indirizzo, Città: record.citta, CAP: record.cap, Provincia: record.provincia, Proprietario: record.proprietario_name, Utente: record.utente_name, Note: record.note}
          }
        });
        //console.log("DATA TO EXPORT", dataExport)
        return jsonExport(dataExport, {
            rowDelimiter: ',',
        }, (err, csv) => {
            downloadCSV('\ufeff'+csv, 'impianti', );
        });
    });
};
const ListActions = () => (
  <TopToolbar>
      <CreateButton label="Crea impianto"/>
      <ExportButton exporter={exporter} label="Esporta dati" maxResults={10000}/>
  </TopToolbar>
);
 
const required = (message = 'Parametro richiesto') =>
  value => value ? undefined : message;

export const ImpiantiForm = () => {
  
    return (
      <SimpleForm 
        mode="onBlur" 
        reValidateMode="onBlur"
        toolbar={<ItasToolbar />}>
        <SelectInput source="stato" choices={choices} optionText="state" optionValue="_id" defaultValue={1} />
        <TextInput  source="descrizione" validate={required()} fullWidth/>
        <TextInput source="indirizzo" validate={required()} fullWidth/>
        <TextInput label="Città" source="citta" validate={required()} fullWidth/>
        <NumberInput source="cap" validate={required()} fullWidth />
        <TextInput source="provincia" validate={required()} fullWidth />
        <ReferenceInput source="id_utente" reference="persone" >
          <AutocompleteInput label="Utente" optionText="nome" fullWidth/>
        </ReferenceInput>
        <ReferenceInput source="id_proprietario" reference="persone" >
          <AutocompleteInput label="Proprietario" optionText="nome" fullWidth/>
        </ReferenceInput>
        <TextInput source="note"  fullWidth />
      </SimpleForm>
  )
}
export const ImpiantiCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
      notify(`Impianto aggiunto`, { type: 'success' });
      redirect(`/impianti`);
  };
  return (
    <Create 
      mutationOptions={{ onSuccess }}
      title="Aggiungi nuovo impianto">
      <ItasEditActions />
      <ImpiantiForm />
    </Create>
  );
}

export const ImpiantiEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = () => {
      notify(`Impianto aggiornato!`, { type: 'success' });
      redirect(`/impianti`);
  };
  const onDelete = () => {
    notify(`Impianto eliminato!`, { type: 'success' });
    redirect(`/impianti`);
};
  return (
    <Edit mutationOptions={{ onSuccess, onDelete }}
          actions={<ItasEditActions />}
          mutationMode="optimistic"
          title="Modifica dettagli impianto"
          >
      <ImpiantiForm edit={true}/>
    </Edit>
  );
}


export const ImpiantiList = () => (
  <List 
      filters={ItasSearchAllFilter} 
      perPage={12}
      pagination={<CustomPagination />}
      actions={<ListActions />}
  >
    <Datagrid>
      
      <TextField source="id" label="ID Impianto" />
      <CustomState source="stato" />
      <TextField source="descrizione" />
      <TextField source="indirizzo" />
      <TextField source="citta" label="Città" />
      <TextField source="cap" />
      <TextField source="provincia" />
      <TextField source="note" />
      <ReferenceField label="Utente" source="id_utente" reference="persone">
        <TextField source="nome" />
      </ReferenceField>
      <ReferenceField label="Proprietario" source="id_proprietario" reference="persone">
        <TextField source="nome" />
      </ReferenceField>
      <ShowButton label="" />
      <EditButton label="" />
    </Datagrid>
  </List>
);